import { TASKMANAGE } from 'Constants/ActionTypes';
// 通用前缀
const url = '/robot';
const actions = {
    getTableList(data) {
        return {
            type: TASKMANAGE.GET_PAGE_LIST,
            payload: {
                request: {
                    method: 'get',
                    url: `${url}/xy/interact/page`,
                    params: data
                },
            },
        };
    },
    getDetailCount(data) {
        return {
            type: TASKMANAGE.GET_DETAIL_COUNT,
            payload: {
                request: {
                    method: 'get',
                    url: `${url}/xy/interact/detailCount/${data.statisticId}`
                },
            },
        };
    },
    getDetailList(data) {
        return {
            type: TASKMANAGE.GET_DETAIL_LIST,
            payload: {
                request: {
                    method: 'get',
                    url: `${url}/xy/interact/detail/${data.statisticId}`,
                    params: { pageNum: data.pageNum, pageSize: data.pageSize }
                },
            },
        };
    },
    // 交互轨迹导出
    interactDownload(data) {
        return {
            type: TASKMANAGE.INTERACT_DOWNLOAD,
            payload: {
                request: {
                    method: 'get',
                    url: `${url}/xy/interact/download`,
                    responseType: "blob",
                    params: { taskIds: data.taskIds, startMillis: data.startMillis, endMillis: data.endMillis, fileType: data.fileType }
                },
            },
        };
    },
    //交互详情导出
    interactDetailDownload(data) {
        return {
            type: TASKMANAGE.INTERACT_DETAIL_DOWNLOAD,
            payload: {
                request: {
                    method: 'get',
                    responseType: "blob",
                    url: `${url}/xy/interact/detail/download/${data.statisticId}?fileType=excel`,
                },
            },
        };
    },
    // 任务管理-任务列表-设置搜索条件
    setSearchData(data) {
        return {
            type: TASKMANAGE.SET_TASK_LIST_SEARCH_DATA,
            data,
        };
    },
    // 任务管理-任务列表-设置pageNum与pageSize
    setPageStatus(data) {
        return {
            type: TASKMANAGE.SET_TASK_LIST_PAGE_STATUS,
            data,
        };
    },
    //设置state的属性值 data：{key，value}的形式
    setState(data) {
        return {
            type: TASKMANAGE.SET_STATE,
            data,
        }
    }
}
export default actions;  